<template>
  <CHeader position="sticky" class="mb-4 shadow-sm border-bottom bg-white">
    <CContainer fluid class="d-flex align-items-center">
      <CHeaderToggler
        class="ps-1 me-3 border-0 bg-transparent"
        @click="$store.commit('toggleSidebar')"
      >
        <CIcon icon="cil-menu" size="lg" />
      </CHeaderToggler>
      <CHeaderNav class="d-none d-md-flex me-auto align-items-center">
        <span class="fw-bold text-dark fs-5">Painel Administrativo</span>
      </CHeaderNav>
      <CHeaderNav class="ms-auto align-items-center">
        <AppHeaderDropdownAccnt />
      </CHeaderNav>
    </CContainer>
  </CHeader>
</template>

<script>
import AppHeaderDropdownAccnt from './AppHeaderDropdownAccnt'
import { logo } from '@/assets/brand/logo'
export default {
  name: 'AppHeader',
  components: {
    AppHeaderDropdownAccnt,
  },
  setup() {
    return {
      logo,
    }
  },
}
</script>
